import { handleAdobeNavEvent } from './adobe-analytics';

// Presses Talkdesk's own launcher, which does nothing while the chat is open.
export const openTalkdeskChat = () => {
  document.getElementById('talkdesk-chat-widget-trigger')?.click();
};

// Delegated so ERB and Vue links only need the class; data-analytics_string
// holds their INP navString.
export const showWebChatOnClick = event => {
  const link = event.target.closest?.('.js-show-web-chat');
  if (!link) return;

  event.preventDefault();
  handleAdobeNavEvent({
    navString: link.getAttribute('data-analytics_string'),
    event,
  });
  openTalkdeskChat();
};
